import {
  JOHOKU_ACCOUNT_TYPE,
  getAnnualSalesTypeName,
  getCapitalTypeName,
  getEmployeeNumTypeName,
  getNyuMonthTypeName,
  getPrefectureName,
} from "enums";
import { CorpBankModel, CorpInfoModel, IndustryMstModel } from "models";
import React from "react";
import { Utils } from "utils";

type PROPS = {
data?: CorpInfoModel;
industryMst: IndustryMstModel[];
isCreate?: boolean;
};

const CorpInfoFormsConfirm: React.FC<PROPS> = (props) => {
const data = props.data;

const getIndustryMajorName = () => {
  const mjr = props.industryMst.find(
    (v) => v.mjr_cd === props.data?.industry_major_cd
  );
  if (mjr) {
    return mjr.title;
  } else {
    return "";
  }
};

const getIndustryMiddleName = () => {
  const mjr = props.industryMst.find(
    (v) => v.mjr_cd === props.data?.industry_major_cd
  );
  console.log(mjr, props.data?.industry_middle_cd);
  if (mjr && mjr.middle_list) {
    const mdl = mjr.middle_list.find(
      (v) => v.mid_cd === props.data?.industry_middle_cd
    );
    if (mdl) {
      return mdl.title;
    }
  }
  return "";
};

const getAccountTypeName = (type: number) => {
  switch (type) {
    case 1:
      return "普通";
    case 2:
      return "当座";
    default:
      return "";
  }
};

const bankAccountListFilter = React.useMemo(() => {
  let has_account = [] as any[];
  let no_account = [] as any[];
  // eslint-disable-next-line array-callback-return
  data?.bank_account_list.map((bank: CorpBankModel) => {
    if(bank.johoku_account_type === JOHOKU_ACCOUNT_TYPE.HAS_ACCOUNT) {
      has_account.push(bank)
    } else {
      no_account.push(bank)
    }
  })
  return {
    has_account,
    no_account
  }
}, [data?.bank_account_list])

if (!data) {
  return <></>;
}

return (
  <>
    <div className="mt-4 flex flex-col gap-4">
      <div className="pt-4 border-b font-bold">
        {props.isCreate ? "会社名登録" : "会社情報"}
      </div>
      <div className="flex justify-between items-center">
        <div className="w-3/12">会社名</div>
        <div className="w-9/12">{data.corp_name}</div>
      </div>
      <div className="flex justify-between items-center">
        <div className="w-3/12">代表者名</div>
        <div className="w-9/12">{data.representative_name}</div>
      </div>
      <div className="flex justify-between items-center">
        <div className="w-3/12">法人個人区分</div>
        <div className="w-9/12">{data.is_personal ? "個人" : "法人"}</div>
      </div>
      {!data.is_personal && (
        <div className="flex justify-between items-center">
          <div className="w-3/12">法人番号</div>
          <div className="w-9/12">{data.corp_no}</div>
        </div>
      )}
      <div className="flex justify-between items-center">
        <div className="w-3/12">適格請求書発行事業者登録番号</div>
        <div className="w-9/12">
          {data.invoice_no === "T" ? "" : data.invoice_no}
        </div>
      </div>
      <div className="flex justify-between items-center">
        <div className="w-3/12">業種</div>
        <div className="w-9/12 flex flex-col">
          <div>
            大分類{props.data?.industry_major_cd} : {getIndustryMajorName()}
          </div>
          <div>
            中分類{props.data?.industry_middle_cd} : {getIndustryMiddleName()}
          </div>
        </div>
      </div>
    </div>

    <div className="mt-4 flex flex-col gap-2">
      <div className="pt-4 border-b font-bold">
        {props.isCreate ? "基本情報登録" : "基本情報"}
      </div>
      <div className="flex justify-between items-center">
        <div className="w-3/12">郵便番号</div>
        <div className="w-9/12 flex gap-4">{data.post_no1}-{data.post_no2}</div>
      </div>
      <div className="flex justify-between items-center">
        <div className="w-3/12">都道府県</div>
        <div className="w-9/12">{getPrefectureName(data.prefecture_cd)}</div>
      </div>
      <div className="flex justify-between items-center">
        <div className="w-3/12">市区町村</div>
        <div className="w-9/12">{data.citytown}</div>
      </div>
      <div className="flex justify-between items-center">
        <div className="w-3/12">住所(番地・建物名等)</div>
        <div className="w-9/12">{data.address}</div>
      </div>
      <div className="flex justify-between items-center">
        <div className="w-3/12">電話番号</div>
        <div className="w-9/12">{data.tel_no}</div>
      </div>
      <div className="flex justify-between items-center">
        <div className="w-3/12">FAX番号</div>
        <div className="w-9/12">{data.fax_no}</div>
      </div>
      <div className="flex justify-between items-center">
        <div className="w-3/12">会社メールアドレス</div>
        <div className="w-9/12">{data.corp_mail_address}</div>
      </div>
      <div className="flex justify-between items-center">
        <div className="w-3/12">会社URL</div>
        <div className="w-9/12">{data.corp_url}</div>
      </div>
      <div className="flex justify-between items-center">
        <div className="w-3/12">設立年月日</div>
        <div className="w-9/12">
          {data.establishment_date.replaceAll("-", "/")}
        </div>
      </div>
      <div className="flex justify-between items-center">
        <div className="w-3/12">資本金</div>
        <div className="w-9/12">{getCapitalTypeName(data.capital_cd)}</div>
      </div>
      <div className="flex justify-between items-center">
        <div className="w-3/12">従業員数</div>
        <div className="w-9/12">
          {getEmployeeNumTypeName(data.employees_number_cd)}
        </div>
      </div>
      <div className="flex justify-between items-center">
        <div className="w-3/12">年商</div>
        <div className="w-9/12">
          {getAnnualSalesTypeName(data.yearly_sales_cd)}
        </div>
      </div>
      <div className="flex justify-between items-center">
        <div className="w-3/12">希望発注限度額</div>
        <div className="w-9/12">
          {Utils.addComma(+data.order_limit * 10000, false)}
        </div>
      </div>
      <div className="flex justify-between items-center">
        <div className="w-3/12">受注時入金条件</div>
        <div className="w-9/12">翌月&nbsp;31日(月末)</div>
      </div>
      <div className="flex justify-between items-center">
        <div className="w-3/12">発注時支払条件</div>
        <div className="w-9/12">
          {getNyuMonthTypeName(data.nyu_month)}&nbsp;
          {data.nyu_day === 31 ? `${data.nyu_day}日(月末)` : `${data.nyu_day}日`}
        </div>
      </div>
      <div className="flex justify-between items-center">
        <div className="w-3/12">振込時の名義人名</div>
        <div className="w-9/12">{data.corp_name_kana}</div>
      </div>
    </div>
    <div className="mt-8 flex flex-col gap-2">
      <div className="pt-4  font-bold">
        {props.isCreate ? "口座登録" : "口座情報"}
      </div>
      {!!bankAccountListFilter.has_account.length && (
        <div className="pt-2 border-t">
          <div className=" border-dashed border-b-2 py-2">
            <div className="flex justify-between items-center">
              <div className="w-3/12">城北信用金庫</div>
              <div className="w-9/12">口座あり</div>
            </div>
          </div>
        </div>
      )}
      {bankAccountListFilter.has_account.map((v, i) => {
        return (
          <div key={i} className="mb-3">
            <div className="flex justify-between items-center">
              <div className="w-3/12">金融機関コード</div>
              <div className="w-9/12">{v.bank_cd}</div>
            </div>
            <div className="flex justify-between items-center">
              <div className="w-3/12">金融機関名</div>
              <div className="w-9/12">{v.bank_name}</div>
            </div>
            <div className="flex justify-between items-center">
              <div className="w-3/12">城北信用金庫支店</div>
              <div className="w-9/12">
                {v.branch_cd}&nbsp;&nbsp;{v.branch_name}
              </div>
            </div>
            <div className="flex justify-between items-center">
              <div className="w-3/12">預金種別</div>
              <div className="w-9/12 flex gap-4">
                {getAccountTypeName(v.account_type)}
              </div>
            </div>
            <div className="flex justify-between items-center">
              <div className="w-3/12">口座番号</div>
              <div className="w-9/12">{v.account_no}</div>
            </div>
            <div className="flex justify-between items-center">
              <div className="w-3/12">口座名義（半角ｶﾅ）</div>
              <div className="w-9/12">{v.account_name}</div>
            </div>
          </div>
        );
      })}
      {!!bankAccountListFilter.no_account.length && (
        <div className="pt-2 border-t">
          <div className="flex justify-between items-center border-dashed border-b-2 py-2">
            <div className="w-3/12">城北信用金庫</div>
            <div className="w-9/12">口座なし</div>
          </div>
        </div>
      )}
      {bankAccountListFilter.no_account.map((v, i) => {
        return (
          <div key={i} className="mb-3 ">
            <div className="flex justify-between items-center">
              <div className="w-3/12">金融機関コード</div>
              <div className="w-9/12">{v.bank_cd}</div>
            </div>
            <div className="flex justify-between items-center">
              <div className="w-3/12">金融機関名</div>
              <div className="w-9/12">{v.bank_name}</div>
            </div>
            <div className="flex justify-between items-center">
              <div className="w-3/12">支店コード</div>
              <div className="w-9/12">{v.branch_cd}</div>
            </div>
            <div className="flex justify-between items-center">
              <div className="w-3/12">支店名</div>
              <div className="w-9/12">{v.branch_name}</div>
            </div>
            <div className="flex justify-between items-center">
              <div className="w-3/12">預金種別</div>
              <div className="w-9/12 flex gap-4">
                {getAccountTypeName(v.account_type)}
              </div>
            </div>
            <div className="flex justify-between items-center">
              <div className="w-3/12">口座番号</div>
              <div className="w-9/12">{v.account_no}</div>
            </div>
            <div className="flex justify-between items-center">
              <div className="w-3/12">口座名義（半角ｶﾅ）</div>
              <div className="w-9/12">{v.account_name}</div>
            </div>
          </div>
        );
      })}
    </div>
  </>
);
};

export default CorpInfoFormsConfirm;
